module.exports = __webpack_public_path__ + "static/media/tata-consumer-products.4baf9d44.svg";